import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { toNumber } from "../../components/Common";
import BSL_Button from "../../components/BSL_Button";
import * as CONFIG from "../../redux_store/configState";
import BracketDesigner from "../main_drawer/BracketDesigner";
import SpecNotesDialog from "../context_options/SpecNotesDialog";
import SpecSlatsTool from "../context_options/SpecSlatsTool";
import SpecAdjustLabels from "../context_options/SpecAdjustLabels";

const useStyles = makeStyles({
    root: {
        padding: "0px 8px 8px 8px",
    },
});

export default function SpecOtherTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);
    const config = useSelector((state) => state.config);
    const user = app.user;
    const { areaIndex } = props;

    const job = useSelector((state) => state.job);
    const [designBracket, setDesignBracket] = React.useState(false);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const designType = area_design_specs?.SHAPE?.DesignType;
    const area_config = config?.design_options?.[designType];

    let deckMode = false;
    if (designType && designType === CONFIG.DESIGN_TYPES.DECK) deckMode = true;

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <SpecNotesDialog areaIndex={areaIndex} />
                {!deckMode && area_config?.slat_options && area_config?.slat_options.length > 0 && (
                    <SpecSlatsTool areaIndex={areaIndex} />
                )}
                <SpecAdjustLabels areaIndex={areaIndex} />
                {toNumber(user?.Role) >= 90 && (
                    <BSL_Common.SectionRow>
                        <BSL_Button
                            style={{ marginLeft: "8px", alignSelf: "center", width: "60%" }}
                            onClick={() => setDesignBracket(true)}
                        >
                            Design Bracket
                        </BSL_Button>
                    </BSL_Common.SectionRow>
                )}
            </BSL_Common.SectionContainer>
            {designBracket && (
                <BracketDesigner
                    mode="Designer"
                    onClose={() => {
                        setDesignBracket(false);
                    }}
                />
            )}
        </div>
    );
}
